export const initialState = {
  clients: [],
  client: {},
  schedules: [],
  employees: [],
  departments: [],
  shifts: [],
  colors: [],
  reports: [],
  loading: false,
  error: null,
};

export const reducer = (state, action) => {
  switch (action.type) {
    case "ADD-CLIENTS": {
      return {
        ...state,
        clients: action.payload.clients,
      };
    }

    case "ADD-CLIENT": {
      return {
        ...state,
        client: action.payload.client,
      };
    }
    case "ADD-SHCEDULES":
      return {
        ...state,
        schedules: action.payload.schedules,
      };
    case "ADD-SHIFTS":
      return {
        ...state,
        shifts: action.payload.shifts,
      };
    case "ADD-DEPARTMENTS":
      return {
        ...state,
        departments: action.payload.departments,
      };
    case "ADD-EMPLOYEES":
      return {
        ...state,
        employees: action.payload.employees,
      };

    case "ADD-COLORS":
      return {
        ...state,
        colors: action.payload.colors,
      };

    case "ADD-REPORTS":
      return {
        ...state,
        reports: action.payload.reports,
      };

    case "LOADING":
      return { ...state, loading: action.payload };
    case "ERROR":
      return { ...state, error: action.payload };
    case "RESET": {
      return {
        ...state,
        client: {},
        schedules: [],
        employees: [],
        departments: [],
        shifts: [],
        colors: [],
        loading: false,
        error: null,
      };
    }

    default:
      return state;
  }
};
